import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HEADERS } from 'src/app/constants/services-headers';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class NetworkIndicatorsService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiNetworkIndicators/" + nameMethod, data, HEADERS);

  // getIndicatorsTechnologicalNetwork(): Obtiene información de los indicadores de la red tecnológica.
  getIndicatorsTechnologicalNetwork = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getFinancialNetworkIndicatorsBdr(): Obtiene información de los indicadores de la red financiera desde los simuladores que se encuentran en Banca de riesgo
  getFinancialNetworkIndicatorsBdr = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getIndicatorsMarketingNetwork(): Obtiene información de los indicadores de la red de Medios y Marketing.
  getIndicatorsMarketingNetwork = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getIndicatorsFinancialNetwork(): Obtiene información de los indicadores de la red financiera
  getIndicatorsFinancialNetwork = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getIndicatorsLegalNetwork(): Obtiene información de los indicadores de la red jurídica.
  getIndicatorsLegalNetwork = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

  // getIndicatorsLegalNetwork(): Obtiene información de los indicadores de cumplimiento reclamación
  getClaimIndicators = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
